import { render, staticRenderFns } from "./DialogAnnounceListImport.vue?vue&type=template&id=1f82bf22&scoped=true&"
import script from "./DialogAnnounceListImport.vue?vue&type=script&lang=js&"
export * from "./DialogAnnounceListImport.vue?vue&type=script&lang=js&"
import style0 from "./DialogAnnounceListImport.vue?vue&type=style&index=0&id=1f82bf22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f82bf22",
  null
  
)

export default component.exports